import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '../../../globals/evasys/environments/environment';

import 'hammerjs';

if (environment.production) {
	enableProdMode();
	const out = window.console.error;
	window.console.error = function (errorType: string, error: Error) {
		const logErrorTypes = ['TypeError'];
		if (logErrorTypes.find((logErrorType) => error?.name?.includes(logErrorType))) {
			out(errorType, error);
		}
	};
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
